import styled from 'styled-components'

export const MainDiv = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #d3d3d3;
`

export const Container = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  padding-top: 10%;
`

export const FormSignIn = styled.form`
  max-width: 400px;
  min-width: 350px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  background: white;
  padding: 20px;
`
